import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Big Oak Studio · Fine Art Photography</p>
        <h1>Discover the Beauty of Fine Art Photography</h1>
        <p className="lede">
          Join us at Big Oak Studio, where we celebrate the artistry of photography through captivating gallery exhibitions and enriching art education programs. Explore, learn, and be inspired.
        </p>
        <div className="cta-row">
          <a href="/exhibitions" target="_self">
            View Current Exhibitions
          </a>
          <a href="/education" target="_self" className="secondary">
            Explore Art Education
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Engaging Exhibitions</h2>
          <p>
            Experience a diverse range of fine art photography from talented artists. Our exhibitions are designed to inspire and provoke thought, inviting you to see the world through a different lens.
          </p>
        </article>
        <article>
          <h2>Art Education Programs</h2>
          <p>
            Enhance your understanding of photography with our educational workshops and classes. Whether you're a beginner or an experienced photographer, we offer programs tailored to all skill levels.
          </p>
        </article>
        <article>
          <h2>Join Our Community</h2>
          <p>
            Become part of a vibrant community of art lovers and photographers. Stay connected through events, discussions, and collaborative projects that celebrate creativity and expression.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;